import React, {Component} from 'react';
import Body from '../Body/Body';
import '../../styles.scss';

class App extends Component {
    render() {
        return (
            <div className='App'>
                <Body />
            </div>
        )
    }
}

export default App;